module.exports = __webpack_public_path__ + "img/download_icon_gray.1c160925.svg";